module.exports = __webpack_public_path__ + "img/1974.20f972bf.png";